/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnersremove1Inputs */

const en_partnersremove1 = /** @type {(inputs: Partnersremove1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

const de_partnersremove1 = /** @type {(inputs: Partnersremove1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernen`)
};

/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Partnersremove1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnersremove1 = /** @type {((inputs?: Partnersremove1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnersremove1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnersremove1(inputs)
	return de_partnersremove1(inputs)
});
export { partnersremove1 as "partnersRemove" }